import React, { useEffect, useState } from 'react';
import ReactPaginate from "react-paginate";
import { useSelector } from 'react-redux';
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { MdOutlineModeEdit } from "react-icons/md";
import Layout from "../../layout";
import services from 'API/services';
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { baseImgUrl, mainUrl } from 'API/client/api';
import axios from 'axios';

const TAEnquiries = () => {
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

    const { userDetail, access_token } = useSelector(authenticationSeletor);

    const { state } = watch()

    const [data, setData] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [total, setTotal] = useState(0);
    const [editMode, setEditMode] = useState(false);
    const [selected, setSelected] = useState({});

    const limit = 10;

    const fetchTSEnqueries = async () => {
        const res = await services.property.tsEnquiriesService(search, page, limit);
        if (res.data.status == true) {
            setData(res.data.data);
            setTotal(res.data.total);
        }
    };

    useEffect(() => {
        fetchTSEnqueries();
    }, [page, search]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    const fetchStates = async () => {
        try {
            const res = await services.globalService.getAllState()
            if (res.status === 200) {
                setStates(res?.data?.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchStates()
    }, []);

    const fetchCities = async () => {
        try {
            const res = await services.globalService.getAllCitiesByState(state)
            if (res.status === 200) {
                setCities(res?.data?.data)
            }
        }
        catch { }
    }

    useEffect(() => {
        fetchCities()
    }, [selected, state]);

    const handleEdit = (data) => {
        setSelected(data)
        setEditMode(true);
        setValue("firstName", data.firstName);
        setValue("lastName", data.lastName);
        setValue("mobile", data.mobile);
        setValue("alternateMobile", data.alternateMobile);
        setValue("email", data.email);
        setValue("state", data.state);
        // setValue("city", data.city);
        setTimeout(() => { setValue("city", data.city) }, 200)
        setValue("pincode", data.pincode);
        setValue("businessName", data.businessName);
        setValue("gstNo", data.gstNo);
        setValue("commission", data.commission);
        setValue("password", data.password);
        setValue("status", data.status);
        setValue("updatedBy", userDetail?.id);
        if (data.bankDetails) {
            try {
                const bank = JSON.parse(data.bankDetails);
                setValue("account", bank.account);
                setValue("ifsc", bank.ifsc);
            } catch (err) { console.log("Invalid bankDetails JSON") }
        }
    };

    const onSubmit = async (data) => {
        try {
            data.bankDetails = JSON.stringify({ account: data.account, ifsc: data.ifsc });
            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                if
                    (key == "panCertificate" || key == "aadharCertificate" || key == "gstCertificate" || key == "cancelCheque") { formData.append(key, data[key][0]) }
                else { formData.append(key, data[key]) }
            });

            const res = await services.property.editTsEnquiriesService(selected.id, formData)
            if (res.data.status === true) {
                setEditMode(false);
                fetchTSEnqueries()
            }
        }
        catch { }
    };

    const handleStatusChange = async (id, status) => {
        try {
            const res = await axios.put(
                `${mainUrl}api/travel-agent/change-status`,
                { taID: id, status: status }, {
                headers: {
                    Authorization: `Bearer ${access_token}`
                }
            }
            );
            if (res.data.status === true) {
                fetchTSEnqueries()
            }
        }
        catch { console.log("error in change travel agent status!") }
    };

    const [previewImage, setPreviewImage] = useState("");
    const [showPreview, setShowPreview] = useState(false);

    const getFileExtension = (filename) => {
        if (!filename) return "";
        return filename.split(".").pop().toLowerCase();
    };

    const isImage = (ext) => ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);
    const isPDF = (ext) => ext === "pdf";
    const isExcel = (ext) => ["xls", "xlsx"].includes(ext);
    const isDoc = (ext) => ["doc", "docx"].includes(ext);

    const renderFile = (file) => {
        if (!file) return "N/A";
        const ext = getFileExtension(file);
        const url = baseImgUrl + file.replace(/^\/uploads/, "");
        if (isImage(ext)) {
            return (
                <img src={url} onClick={() => { setPreviewImage(url); setShowPreview(true) }} style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "6px", cursor: "pointer" }} />
            );
        }
        if (isPDF(ext)) {
            return (
                <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#007bff", textDecoration: "underline" }}>View PDF</a>
            );
        }
        if (isExcel(ext)) {
            return (
                <a href={url} download style={{ color: "green", textDecoration: "underline" }}>Download Excel</a>
            );
        }
        if (isDoc(ext)) {
            return (
                <a href={url} download style={{ color: "#007bff", textDecoration: "underline" }}>Download Document</a>
            );
        }
        return (
            <a href={url} download style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}>Download</a>
        );
    };


    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-center mb-2'>
                <h4>TA Enquries</h4>
                <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearch}
                    style={{
                        padding: "8px",
                        width: "250px",
                        border: "1px solid #ccc",
                        borderRadius: "4px"
                    }}
                />
            </div>
            <table className='dashboard-table'>
                <thead>
                    <tr>
                        <th>Business</th>
                        <th>TA Code</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>State</th>
                        <th>City</th>
                        <th>Bank Details</th>
                        <th>Commission</th>
                        <th>Pan</th>
                        <th>Aadhar</th>
                        <th>GST</th>
                        <th>Cheque</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {data?.map((item) => {
                        let bank = JSON.parse(item?.bankDetails)
                        return (
                            <tr key={item?.id}>
                                <td data-label="Business">{item?.businessName}</td>
                                <td data-label="TA Code">{item?.taCode}</td>
                                <td data-label="Name">{item?.firstName + ' ' + item?.lastName}</td>
                                <td data-label="Email">{item?.email}</td>
                                <td data-label="Mobile">{item?.mobile}</td>
                                <td data-label="State">{item?.stateName?.name}</td>
                                <td data-label="City">{item?.cityName?.name}({item?.pincode})</td>
                                <td data-label="Bank Details">
                                    {
                                        item?.bankDetails ? (
                                            <>
                                                <p className='fs-8 mb-0'>Account - {bank?.account}</p>
                                                <p className='fs-8 mb-0'>IFSC - {bank?.ifsc}</p>
                                            </>
                                        ) : 'N/A'
                                    }
                                </td>
                                <td data-label="Commission">{item?.commission ?? 'N/A'}</td>
                                <td data-label="Pan">{renderFile(item?.panCertificate)}</td>
                                <td data-label="Aadhar">{renderFile(item?.aadharCertificate)}</td>
                                <td data-label="GST">{renderFile(item?.gstCertificate)}</td>
                                <td data-label="Cheque">{renderFile(item?.cancelCheque)}</td>
                                <td data-label="Action">
                                    <button
                                        type='button'
                                        style={{ fontSize: '10px', width: "53px" }}
                                        className={item.status == 1 ? 'btn btn-success btn-sm me-1' : 'btn btn-danger btn-sm me-1'}
                                        onClick={() => handleStatusChange(item?.id, item?.status == 1 ? 0 : 1)}>
                                        {item?.status == 1 ? "Active" : "In-active"}
                                    </button>
                                    <button type='button' className='btn btn-primary btn-sm' onClick={() => handleEdit(item)}>
                                        <MdOutlineModeEdit size={18} />
                                    </button>
                                </td>
                                {showPreview && (
                                    <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0, 0, 0, 0.18)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }} onClick={() => setShowPreview(false)}>
                                        <img src={previewImage} style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "10px", boxShadow: "0 0 20px rgba(0,0,0,0.5)" }} />
                                    </div>
                                )}
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <div className='mt-4'>
                {
                    data?.length > 0 &&
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        pageCount={Math.ceil(total / limit)}
                        onPageChange={handlePageClick}
                        className="paginationParent"
                        containerClassName={"pagination"}
                        activeClassName={"activePaginationBtn"}
                    />
                }
            </div>
            <Modal show={editMode} onHide={() => setEditMode(false)} centered size="lg">
                <Modal.Header closeButton><Modal.Title>TA Enquiry Form</Modal.Title></Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)} className="p-3">
                        <div className="row">
                            {/* First Name */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>First Name</label>
                                <input className="form-control" {...register("firstName", { required: "Required" })} />
                                {errors.firstName && <small className="text-danger">{errors.firstName.message}</small>}
                            </div>
                            {/* Last Name */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Last Name</label>
                                <input className="form-control" {...register("lastName", { required: "Required" })} />
                                {errors.lastName && <small className="text-danger">{errors.lastName.message}</small>}
                            </div>
                            <div className="col-md-4 mb-3 d-none">
                                <label className='field-label'>Updated By</label>
                                <input className="form-control" defaultValue={userDetail?.id} value={userDetail?.id} {...register("updatedBy", { required: "Required" })} />
                                {errors.updatedBy && <small className="text-danger">{errors.updatedBy.message}</small>}
                            </div>
                            {/* Mobile */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Mobile</label>
                                <input
                                    className="form-control"
                                    maxLength={10}
                                    {...register("mobile", {
                                        required: "Mobile number is required",
                                        pattern: {
                                            value: /^[0-9]{10}$/,
                                            message: "Enter a valid 10-digit mobile number",
                                        },
                                    })}
                                    placeholder="Enter your Mobile"
                                />
                                {errors.mobile && <small className="text-danger">{errors.mobile.message}</small>}
                            </div>
                            {/* Alternate Mobile */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Alternate Mobile</label>
                                <input
                                    className="form-control"
                                    maxLength={10}
                                    {...register("alternateMobile", {
                                        required: "Mobile number is required",
                                        pattern: {
                                            value: /^[0-9]{10}$/,
                                            message: "Enter a valid 10-digit mobile number",
                                        },
                                    })}
                                    placeholder="Enter your Alternate Mobile"
                                />
                                {errors.alternateMobile && (
                                    <small className="text-danger">{errors.alternateMobile.message}</small>
                                )}
                            </div>
                            {/* Email */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Email</label>
                                <input
                                    className="form-control"
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Enter a valid email address",
                                        },
                                    })}
                                    placeholder="Enter your Email"
                                />
                                {errors.email && <small className="text-danger">{errors.email.message}</small>}
                            </div>
                            {/* State */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>State</label>
                                <select
                                    className="form-control"
                                    {...register("state", { required: "Required" })}
                                >
                                    {states?.map((s) => (
                                        <option key={s.iso2} value={s.id}>
                                            {s.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.state && <small className="text-danger">{errors.state.message}</small>}
                            </div>
                            {/* City */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>City</label>
                                <select className="form-control"{...register("city", { required: "Required" })}>
                                    {cities.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.city && <small className="text-danger">{errors.city.message}</small>}
                            </div>
                            {/* Pincode */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Pincode</label>
                                <input
                                    className="form-control"
                                    maxLength={6}
                                    {...register("pincode", {
                                        required: "Pincode is required",
                                        pattern: {
                                            value: /^[0-9]{6}$/,
                                            message: "Enter a valid 6-digit pincode",
                                        },
                                    })}
                                    placeholder="Enter your Pincode"
                                />
                                {errors.pincode && <small className="text-danger">{errors.pincode.message}</small>}
                            </div>
                            {/* Business Name */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Business Name</label>
                                <input className="form-control" {...register("businessName", { required: "Required" })} />
                                {errors.businessName && (
                                    <small className="text-danger">{errors.businessName.message}</small>
                                )}
                            </div>
                            {/* GST No */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>GST No</label>
                                <input
                                    className="form-control"
                                    {...register("gstNo", {
                                        required: "GST Number is required",
                                        pattern: {
                                            value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                            message: "Enter a valid GST number (15 characters)"
                                        },
                                    })}
                                    placeholder='Enter GST Number'
                                />
                                {errors.gstNo && <small className="text-danger">{errors.gstNo.message}</small>}
                            </div>
                            {/* Bank - Account */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Bank Account Number</label>
                                <input
                                    className="form-control"
                                    {...register("account", {
                                        required: "Account Number is required",
                                        pattern: {
                                            value: /^[0-9]{9,18}$/,
                                            message: "Account number must be 9 to 18 digits",
                                        },
                                    })}
                                    placeholder='Enter Bank Account Number'
                                />
                                {errors.account && <small className="text-danger">{errors.account.message}</small>}
                            </div>
                            {/* Bank - IFSC */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>IFSC Code</label>
                                <input
                                    className="form-control"
                                    {...register("ifsc", {
                                        required: "IFSC is required",
                                        pattern: {
                                            value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                                            message: "Enter valid IFSC (e.g. HDFC0001234)",
                                        },
                                    })}
                                    placeholder='Enter IFSC Code'
                                />
                                {errors.ifsc && <small className="text-danger">{errors.ifsc.message}</small>}
                            </div>
                            {/* Commission */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Commission</label>
                                <input
                                    className="form-control"
                                    {...register("commission", {
                                        required: "Commission is required",
                                    })}
                                    placeholder='Enter Commission'
                                />
                                {errors.commission && <small className="text-danger">{errors.commission.message}</small>}
                            </div>
                            {/* Password */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Password</label>
                                <input
                                    className="form-control"
                                    {...register("password", {
                                        required: "Password is required",
                                    })}
                                    placeholder='Enter Password'
                                />
                                {errors.password && <small className="text-danger">{errors.password.message}</small>}
                            </div>
                            {/* Status */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Status</label>
                                <select className="form-control" {...register("status", { required: "Required" })}>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                {errors.status && <small className="text-danger">{errors.status.message}</small>}
                            </div>
                            {/* PAN Certificate */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>PAN Certificate</label>
                                <input
                                    type="file"
                                    className="form-control pt-2"
                                    {...register("panCertificate")}
                                />
                            </div>
                            {/* Aadhaar Certificate */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Aadhar Certificate</label>
                                <input
                                    type="file"
                                    className="form-control pt-2"
                                    {...register("aadharCertificate")}
                                />
                            </div>
                            {/* GST Certificate */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>GST Certificate</label>
                                <input
                                    type="file"
                                    className="form-control pt-2"
                                    {...register("gstCertificate")}
                                />
                            </div>
                            {/* Cancel Cheque */}
                            <div className="col-md-4 mb-3">
                                <label className='field-label'>Cancel Cheque</label>
                                <input
                                    type="file"
                                    className="form-control pt-2"
                                    {...register("cancelCheque")}
                                />
                            </div>
                        </div>
                        <button className="btn btn-primary mt-3">Submit</button>
                    </form>
                </Modal.Body>
            </Modal>
        </Layout>
    );
};

export default TAEnquiries;
